import { apiAuth } from "../../http";

export const getProfilesAll = async (): Promise<any> => {
  const response = apiAuth()
    .get("/profiles")
    .then(({ data }) => data);
  return response;
};
